import { Box, Button, InputAdornment, Stack, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import EventCard from "./EventCard";
import SearchIcon from "@mui/icons-material/Search";
import ThriveModal from "../../common/ThriveModal";
import ThriveCaseSelection from "../../common/ThriveCaseSelection";
import NoticeDialog from "../../common/NoticeDialog";
import { NavLink } from "react-router-dom";
import { EventType } from "../../../interfaces";
import EmailEditor from "../../common/EmailEditor";
import { EventInvitation } from "../../common/EmailBodies/EventInvitation";
import { axiosInstance, fetchInstance } from "../../../utils/networking";
const Events = (props: any) => {
  const [eventEmailTos, setEventEmailTos] = useState([]);
  const [checkedCases, setCheckedCases] = useState<string[]>([]);
  const [selectedCase, setSelectedCase] = useState<any>({ firmRecord: {} });
  const [availableEvents, setAvailableEvents] = useState<EventType[]>([]);
  const [displayEvents, setDisplayEvents] = useState<EventType[]>([]);
  const [selectedEvent, setSelectedEvent] = useState("");
  const [invitationOpen, setInvitationOpen] = useState(false);
  const [editorOpen, setEditorOpen] = useState(false);
  const [messageOpen, setMessageOpen] = useState(false);
  const [messageTitle, setMessageTitle] = useState("");
  const [messageBody, setMessageBody] = useState("");
  const [dataFlag, setDataFlag] = useState(false);
  useEffect(() => {
    axiosInstance.get(`/events`).then((res) => {
      setAvailableEvents(res.data.events);
      setDisplayEvents(res.data.events);
    });
  }, []);

  const handleEventSearch = (e: any) => {
    setDisplayEvents(
      availableEvents.filter((event: EventType) => {
        return (event.name.text + event.description.text)
          .toLowerCase()
          .includes(e.target.value.toLowerCase());
      })
    );
  };

  const handleSendInvitation = () => {
    setInvitationOpen(false);
    setEditorOpen(true);
  };

  return (
    <Box>
      <Stack direction={"row"} spacing={2}>
        {/* <Box sx={{ width: "30%" }}>
          <Stack>
            <Box>Tag Search Bar</Box>

            <Box>Tag List</Box>
          </Stack>
        </Box> */}

        <Box sx={{ width: "100%" }}>
          <Stack spacing={2}>
            <TextField
              label="Search Events..."
              variant="outlined"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              onChange={handleEventSearch}
            ></TextField>
            <NavLink to="/dashboard/pastevents">
              <Button sx={{ color: "#b3197a" }}>Past Events and Surveys</Button>
            </NavLink>

            {/* <Box>Event Category</Box> */}
            <Stack>
              {displayEvents.map((event: EventType, index: number) => {
                return (
                  <EventCard
                    key={index}
                    event={event}
                    displayButton={true}
                    setInvitationOpen={setInvitationOpen}
                    setSelectedEvent={setSelectedEvent}
                  ></EventCard>
                );
              })}
            </Stack>
          </Stack>
        </Box>
      </Stack>
      <ThriveModal
        open={invitationOpen}
        setOpen={setInvitationOpen}
        closeByClick={true}
        contentComponent={
          <ThriveCaseSelection
            height={400}
            cases={[]}
            reloadCases={true}
            checkedCases={checkedCases}
            setCheckedCases={setCheckedCases}
            selectedCase={selectedCase}
            setSelectedCase={setSelectedCase}
            setOpen={setInvitationOpen}
            enableControl={true}
            enableSelection={true}
            enableMultiSelection={true}
            title={"Send Event Invitation"}
            status_default="either"
            sortby_default="recent"
            period_default="all"
            handleNext={handleSendInvitation}
            setEventEmailTos={setEventEmailTos}
          ></ThriveCaseSelection>
        }
      ></ThriveModal>
      <ThriveModal
        height={750}
        open={editorOpen}
        setOpen={setEditorOpen}
        closeByClick={true}
        contentComponent={
          <EmailEditor
            setOpen={setEditorOpen}
            theCase={{}}
            theFirm={{}}
            theReferral={{}}
            editorTitle={"Event Invitation"}
            theSubject={"Event Invitation"}
            theSelectedEvent={selectedEvent}
            theSelectedProvider={{}}
            bodyGenerator={EventInvitation}
            setMessageOpen={setMessageOpen}
            setMessageTitle={setMessageTitle}
            setMessageBody={setMessageBody}
            eventEmailTos={eventEmailTos}
            theBFC={{}}
          ></EmailEditor>
        }
      ></ThriveModal>
      <ThriveModal
        open={messageOpen}
        setOpen={setMessageOpen}
        closeByClick={true}
        height={200}
        width={500}
        contentComponent={
          <NoticeDialog
            title={"Email Sent!"}
            setOpen={setMessageOpen}
            setDataFlag={setDataFlag}
          ></NoticeDialog>
        }
      ></ThriveModal>
    </Box>
  );
};

export default Events;
